<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="账号ID"
                        prop="name">
            <el-input placeholder="请输入账号ID"
                      clearable
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="账号"
                        prop="name">
            <el-input placeholder="请输入账号名"
                      clearable
                      v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="用户姓名"
                        prop="realname">
            <el-input placeholder="请输入用户姓名"
                      clearable
                      v-model="search.realname"></el-input>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="phone">
            <el-input placeholder="请输入手机号"
                      clearable
                      v-model="search.phone"></el-input>
          </el-form-item>
          <el-form-item label="人员性质"
                        prop="employment_type">
            <el-select placeholder="请选择人员性质"
                       class="width-max"
                       v-model="search.employment_type"
                       clearable>
              <el-option v-for="(label, value) in employmentTypeMap"
                         :key="value"
                         :label="label"
                         :value="value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户状态"
                        prop="status">
            <el-select placeholder="请选择"
                       class="width-max"
                       v-model="search.status"
                       clearable>
              <el-option v-for="(label, value) in statusMap"
                         :key="value"
                         :label="label"
                         :value="value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参与客户"
                        prop="participant_customer">
            <remote-select class="width-max"
                           v-model="search.participant_customer"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请选择客户"
                           :query-request="getCustomerTable"
                           :find-request="getCustomerDetail"
                           multiple>
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button v-if="allowViewInternTable()"
                     icon="sj-icon-export"
                     @click="onExportBaseInfo()">
            导出基础信息
          </el-button>
          <el-button v-if="allowExportPrivateData()"
                     icon="sj-icon-export"
                     @click="onExportFullInfo()">
            导出全部信息
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <button-gutter>
          <router-link :to="'/audit-intern/create'">
            <el-button type="primary"
                       v-if="allowCreateIntern()"
                       icon="sj-icon-add"
                       size="small">新增用户
            </el-button>
          </router-link>
          <el-button type="primary"
                     v-if="allowCreateIntern()"
                     icon="sj-icon-add"
                     size="small"
                     @click="batchAddIntern()">批量添加实习生
          </el-button>
          <el-button type="warning"
                     v-if="allowViewEditBase()"
                     icon="sj-icon-add"
                     size="small"
                     @click="batchEditInternBase()">批量修改基础资料
          </el-button>
          <el-button type="warning"
                     v-if="allowViewEditPrivate()"
                     icon="sj-icon-add"
                     size="small"
                     @click="batchEditInternPrivate()">批量修改隐私信息
          </el-button>
          <el-button type="warning"
                     v-if="allowViewEditResource()"
                     icon="sj-icon-add"
                     size="small"
                     @click="batchEditInternResource()">批量修改资源限制
          </el-button>
        </button-gutter>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <template v-for="attr of tableColumns">
          <el-table-column v-if="attr.prop === 'participant_customers'"
                           v-bind="attr">
            <template slot-scope="scope">
              <el-tooltip class="item"
                          effect="dark"
                          :content="scope.row[attr.prop] + ''"
                          placement="top">
                <div class="ellipsis-cell">{{ scope.row[attr.prop] }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-else
                           v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="160">
          <template slot-scope="scope">
            <div>
              <el-link :href="`/audit-intern/detail/${scope.row.id}`"
                       type="primary">
                详情
              </el-link>
              <span class="el-divider el-divider--vertical"></span>
              <el-link :href="`/audit-intern/update/${scope.row.id}`"
                       v-if="allowEditInfo()"
                       type="primary">
                修改
              </el-link>
            </div>
            <div>
              <el-link :href="qualityHref(scope.row)"
                       v-permission="40013"
                       type="primary">
                实习质量
              </el-link>
            </div>
            <div>
              <el-button @click="activeAdmin(scope.row)"
                         type="text">
                激活
              </el-button>
              <span class="el-divider el-divider--vertical"
                    v-if="allowEditInfo()"></span>
              <el-button @click="convertToFulltime(scope.row)"
                         v-if="allowEditInfo()"
                         type="text">
                转为全职
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog :title="dialogCfg.title"
               :visible.sync="dialogCfg.dialogVisible"
               width="600px"
               @close="closeDialog()">
      <el-form ref="batchAddForm"
               label-width="120px">
        <el-form-item label="下载模板">
          <el-button type="success"
                     icon="el-icon-download"
                     size="small"
                     @click="handleDownDemoFile()">下载Excel模板
          </el-button>
        </el-form-item>
        <el-form-item label="上传文件"
                      prop="file"
                      :rules="[{ required: true, message: '请上传Excel文件' }]">
          <el-upload class="upload-demo"
                     ref="upload"
                     :limit="1"
                     action="#"
                     :auto-upload="false"
                     :on-change="handleFileChange"
                     :file-list="dialogCfg.fileList"
                     accept=".xlsx"
                     drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip"
                 slot="tip">只能上传 xlsx 格式的文件
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button type="primary"
                   :disabled="dialogCfg.fileList.length === 0"
                   :loading="dialogCfg.batchAddLoading"
                   @click="dialogCfg.createCrontab()">确定上传
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import auditIntern from '../audit-intern.mixins.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, { removeEmptyParams, trimParams } from '@core/mixins/table-v3'
import RemoteSelect from '@core/components/RemoteSelect.vue'

export default {
  components: {RemoteSelect},
  mixins: [table, dateTimePicker, auditIntern],
  data () {
    return {
      search: {
        id: null,
        name: null,
        realname: null,
        phone: null,
        employment_type: null,
        status: null,
        participant_customer: [],
      },
      dialogCfg: {
        title: '',
        dialogVisible: false,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: () => {},
        createCrontab: () => {},
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([
      'getCustomerTable', 'getCustomerDetail', 'exportInternBaseInfoApi',
      'exportInternFullInfoApi'
    ]),
    isSuperAdmin () {
      return filter.superPermission()
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryInternTableApi', params).then(response => {
        response.data.data = response.data.data.map((item) => {
          item.participant_customers = item.participant_customers.map(customer => `${customer.name}/${customer.id}`).join(', ')
          return item
        })
        return response
      })
    },
    allowEditInfo () {
      return this.allowViewEditBase() || this.allowViewEditPrivate() || this.allowViewEditResource() || this.allowViewEditUserResource()
    },
    qualityHref (row) {
      return `/audit-intern/performance?intern_user_id=${row.id}`
    },
    activeAdmin (row) {
      request.common('activeInternStatusBaseApi', {id: row.id}).then(() => {
        this.$message.success('用户状态激活成功')
        this.onRefresh()
      })
    },
    convertToFulltime (row) {
      this.$confirm(`确认将账号「${row.name}」转为全职管理员？转后将不再出现在实习生列表，客户资源与角色会保留。`, '转为全职', {
        type: 'warning',
        confirmButtonText: '确认转换',
        cancelButtonText: '取消',
      }).then(() => {
        return request.common('convertInternToFulltimeApi', {id: row.id})
      }).then(() => {
        this.$message.success('已转为全职账号')
        this.onRefresh()
      }).catch(() => {})
    },
    onExportBaseInfo () {
      this.$export('导出实习生基础信息', {
        fileHeader: this.exportBaseHeader,
        total: this.pagination.total,
        request: this.exportInternBaseInfoApi,
        requestParams: removeEmptyParams(trimParams(_.cloneDeep(this.search))),
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    onExportFullInfo () {
      this.$export('导出实习生全部信息', {
        fileHeader: this.exportFullHeader,
        total: this.pagination.total,
        request: this.exportInternFullInfoApi,
        requestParams: removeEmptyParams(trimParams(_.cloneDeep(this.search))),
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        row.employment_type = _.get(this.employmentTypeMap, _.get(row, 'employment_type'), '')
        row.status = _.get(this.statusMap, _.get(row, 'status'), '')
        row.grade_level = _.get(this.gradeLevelMap, _.get(row, 'grade_level'), '')
        row.education_level = _.get(this.educationLevelMap, _.get(row, 'education_level'), '')
        row.office_location = _.get(this.officeLocationMap, _.get(row, 'office_location'), '')
        row.contract_start_date = this.formatDateStr(_.get(row, 'contract_start_date', ''))
        row.contract_end_date = this.formatDateStr(_.get(row, 'contract_end_date', ''))

        row.student_card_photos = Array.isArray(_.get(row, 'student_card_photos')) ? row.student_card_photos : []
        row.assigned_customers = Array.isArray(_.get(row, 'assigned_customers')) ? row.assigned_customers : []
        row.ui_roles = Array.isArray(_.get(row, 'ui_roles')) ? row.ui_roles : []
        row.api_roles = Array.isArray(_.get(row, 'api_roles')) ? row.api_roles : []
        row.participant_customers = Array.isArray(_.get(row, 'participant_customers')) ? row.participant_customers : []
        row.participant_projects = Array.isArray(_.get(row, 'participant_projects')) ? row.participant_projects : []
        row.bank_card_photo = Array.isArray(_.get(row, 'bank_card_photo')) ? row.bank_card_photo : []
        row.student_card_photos = row.student_card_photos.join(', ')
        row.bank_card_photo = row.bank_card_photo.join(', ')
        row.assigned_customers = row.assigned_customers.map(item => `${item.name}/${item.id}`).join(',')
        row.ui_roles = row.ui_roles.map(item => `${item.name}/${item.id}`).join(',')
        row.api_roles = row.api_roles.map(item => `${item.name}/${item.id}`).join(',')
        row.participant_customers = row.participant_customers.map(item => `${item.name}/${item.id}`).join(',')
        row.participant_projects = row.participant_projects.map(item => `${item.name}/${item.id}`).join(',')
      })
      return data
    },
    formatDateStr (str, prefix = 'sj:') {
      if (str) {
        return prefix + str.slice(0, 10)
      }
      return ''
    },
    batchAddIntern () {
      Object.assign(this.dialogCfg, {
        title: '批量添加实习生',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: () => this.downBatchCreateInternDemo(),
        createCrontab: () => this.handleBatchAddSubmit(),
      })
    },
    batchEditInternBase () {
      Object.assign(this.dialogCfg, {
        title: '批量修改实习生基础资料',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: () => this.downBatchEditBaseDemo(),
        createCrontab: () => this.handleBatchEditBaseSubmit(),
      })
    },
    batchEditInternPrivate () {
      Object.assign(this.dialogCfg, {
        title: '批量修改实习生隐私信息',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: () => this.downBatchEditPrivateDemo(),
        createCrontab: () => this.handleBatchEditPriSubmit(),
      })
    },
    batchEditInternResource () {
      Object.assign(this.dialogCfg, {
        title: '批量修改实习生资源限制',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: () => this.downBatchEditResourceDemo(),
        createCrontab: () => this.handleBatchEditResSubmit(),
      })
    },
    closeDialog () {
      this.dialogCfg.dialogVisible = false
      this.$refs.batchAddForm.resetFields()
      this.dialogCfg.fileList = []
    },
    handleDownDemoFile () {
      this.dialogCfg.downDemoFile()
    },
    handleFileChange (file, fileList) {
      this.dialogCfg.fileList = fileList
    },
    downBatchCreateInternDemo () {
      let demo = [{
        name: '实习生张三',
        password: 'User@123',
        realname: '张三',
        employment_type: '兼职',
        office_location: '临港',
        phone: '13112345678',
        mail_address: 'person@example.com',
        school: '上海xxx大学',
        major: 'xxx专业',
        education_level: '本科',
        grade_level: '大三',
        student_card_photos: 'a.jpg,b.jpg,c.jpg',
        contract_start_date: 'sj:2025-11-01',
        contract_end_date: 'sj:2026-03-01',
        remark: '这里是备注文字',
        id_number: 'xxxxxxx',
        id_card_front_photo: '正面.jpg',
        id_card_back_photo: '反面.jpg',
        bank_name: '中国工商银行',
        bank_branch_name: 'xxx支行信息',
        bank_card_number: '62128888888888',
        bank_card_photo: '银行卡1.jpg,银行卡2.jpg',
      }, {
        name: '登录账号名,必填',
        password: '选填,留空为默认值:User@123',
        realname: '必填',
        employment_type: '必填,可选参数: 实习生/兼职',
        office_location: '必填,可选参数: 临港,陆家嘴,客户公司,线上,成都,其他',
        phone: '必填',
        mail_address: '选填',
        school: '选填',
        major: '选填',
        education_level: '选填',
        grade_level: '选填,可选参数: 大一、大二、大三、大四、研一、研二、研三、已毕业',
        student_card_photos: '照片链接,多张照片使用,分隔',
        contract_start_date: '必填',
        contract_end_date: '必填',
        remark: '选填',
        id_number: '选填',
        id_card_front_photo: '选填',
        id_card_back_photo: '选填',
        bank_name: '选填',
        bank_branch_name: '选填',
        bank_card_number: '选填',
        bank_card_photo: '选填,多张照片使用,分隔',
      }]
      const fileHeader = [
        {key: 'name', text: '账号'},
        {key: 'password', text: '密码'},
        {key: 'realname', text: '姓名'},
        {key: 'employment_type', text: '人员性质'},
        {key: 'office_location', text: '办公地点'},
        {key: 'phone', text: '手机号'},
        {key: 'mail_address', text: '个人邮箱'},
        {key: 'school', text: '目前所在院校'},
        {key: 'major', text: '专业'},
        {key: 'education_level', text: '学历'},
        {key: 'grade_level', text: '当前学年段'},
        {key: 'student_card_photos', text: '学生证照片'},
        {key: 'contract_start_date', text: '合同开始时间'},
        {key: 'contract_end_date', text: '合同结束时间'},
        {key: 'remark', text: '备注'},
        {key: 'id_number', text: '身份证号'},
        {key: 'id_card_front_photo', text: '身份证正面照片'},
        {key: 'id_card_back_photo', text: '身份证反面照片'},
        {key: 'bank_name', text: '银行名称'},
        {key: 'bank_branch_name', text: '支行信息'},
        {key: 'bank_card_number', text: '银行卡号'},
        {key: 'bank_card_photo', text: '银行卡照片'},
      ]
      this.$export(this.dialogCfg.title + '模板', demo, {fileHeader})
    },
    downBatchEditBaseDemo () {
      let demo = [{
        id: '9999999',
        name: '实习生张三',
        password: '',
        realname: '张三',
        employment_type: '兼职',
        office_location: '临港',
        status: '活跃',
        phone: '13112345678',
        mail_address: 'person@example.com',
        school: '上海xxx大学',
        major: 'xxx专业',
        education_level: '本科',
        grade_level: '大三',
        student_card_photos: 'a.jpg,b.jpg,c.jpg',
        contract_start_date: 'sj:2025-11-01',
        contract_end_date: 'sj:2026-03-01',
        remark: '这里是备注文字',
      }, {
        id: '账号ID,必填',
        name: '登录账号名,选填',
        password: '选填,无需修改时留空',
        realname: '必填',
        employment_type: '必填,可选参数: 实习生/兼职',
        office_location: '必填,可选参数: 临港,陆家嘴,客户公司,线上,成都,其他',
        status: '必填,可选参数: 活跃/待机/离职',
        phone: '必填',
        mail_address: '选填',
        school: '选填',
        major: '选填',
        education_level: '选填',
        grade_level: '选填,可选参数: 大一、大二、大三、大四、研一、研二、研三、已毕业',
        student_card_photos: '照片链接,多张照片使用,分隔',
        contract_start_date: '必填',
        contract_end_date: '必填',
        remark: '选填',
      }]
      const fileHeader = [
        {key: 'id', text: '账号ID'},
        {key: 'name', text: '账号'},
        {key: 'password', text: '密码'},
        {key: 'realname', text: '姓名'},
        {key: 'employment_type', text: '人员性质'},
        {key: 'office_location', text: '办公地点'},
        {key: 'status', text: '状态'},
        {key: 'phone', text: '手机号'},
        {key: 'mail_address', text: '个人邮箱'},
        {key: 'school', text: '目前所在院校'},
        {key: 'major', text: '专业'},
        {key: 'education_level', text: '学历'},
        {key: 'grade_level', text: '当前学年段'},
        {key: 'student_card_photos', text: '学生证照片'},
        {key: 'contract_start_date', text: '合同开始时间'},
        {key: 'contract_end_date', text: '合同结束时间'},
        {key: 'remark', text: '备注'},
      ]
      this.$export(this.dialogCfg.title + '模板', demo, {fileHeader})
    },
    downBatchEditPrivateDemo () {
      let demo = [{
        id: '9999999',
        id_number: 'xxxxxxx',
        id_card_front_photo: '正面.jpg',
        id_card_back_photo: '反面.jpg',
        bank_name: '中国工商银行',
        bank_branch_name: 'xxx支行信息',
        bank_card_number: '62128888888888',
        bank_card_photo: '银行卡1.jpg,银行卡2.jpg',
      }, {
        id: '账号ID,必填',
        id_number: '必填',
        id_card_front_photo: '选填',
        id_card_back_photo: '选填',
        bank_name: '选填',
        bank_branch_name: '选填',
        bank_card_number: '选填',
        bank_card_photo: '选填,多张照片使用,分隔',
      }]
      const fileHeader = [
        {key: 'id', text: '账号ID'},
        {key: 'id_number', text: '身份证号'},
        {key: 'id_card_front_photo', text: '身份证正面照片'},
        {key: 'id_card_back_photo', text: '身份证反面照片'},
        {key: 'bank_name', text: '银行名称'},
        {key: 'bank_branch_name', text: '支行信息'},
        {key: 'bank_card_number', text: '银行卡号'},
        {key: 'bank_card_photo', text: '银行卡照片'},
      ]
      this.$export(this.dialogCfg.title + '模板', demo, {fileHeader})
    },
    downBatchEditResourceDemo () {
      let demo = [{
        id: '9999999',
        assigned_customers: '联合利华/100,恰恰/101',
        ui_roles: '角色/1,角色/5',
        api_roles: '角色/6,角色/15',
      }, {
        id: '账号ID,必填',
        assigned_customers: '留空时重置客户资源为空',
        ui_roles: '留空时重置UI角色为空',
        api_roles: '留空时重置API角色为空',
      }]
      const fileHeader = [
        {key: 'id', text: '账号ID'},
        {key: 'assigned_customers', text: '客户资源'},
        {key: 'ui_roles', text: 'UI角色'},
        {key: 'api_roles', text: 'API角色'},
      ]
      this.$export(this.dialogCfg.title + '模板', demo, {fileHeader})
    },
    handleBatchAddSubmit () {
      const formData = new FormData()
      formData.append('file', this.dialogCfg.fileList[0].raw)
      request.common('batchCreateInternApi', formData).then(({data}) => {
        this.$message.success('任务创建成功')
        this.closeDialog()
      }).finally(() => {
        this.loading = false
      })
    },
    handleBatchEditBaseSubmit () {
      const formData = new FormData()
      formData.append('file', this.dialogCfg.fileList[0].raw)
      formData.append('handle_mode', 'base_info')
      request.common('batchEditInternApi', formData).then(({data}) => {
        this.$message.success('任务创建成功')
        this.closeDialog()
      }).finally(() => {
        this.loading = false
      })
    },
    handleBatchEditPriSubmit () {
      const formData = new FormData()
      formData.append('file', this.dialogCfg.fileList[0].raw)
      formData.append('handle_mode', 'private_info')
      request.common('batchEditInternApi', formData).then(({data}) => {
        this.$message.success('任务创建成功')
        this.closeDialog()
      }).finally(() => {
        this.loading = false
      })
    },
    handleBatchEditResSubmit () {
      const formData = new FormData()
      formData.append('file', this.dialogCfg.fileList[0].raw)
      formData.append('handle_mode', 'resource_info')
      request.common('batchEditInternApi', formData).then(({data}) => {
        this.$message.success('任务创建成功')
        this.closeDialog()
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss">
.ellipsis-cell {
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置伸缩盒子的子元素排列方式为垂直排列 */
  -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
  line-clamp: 2; /* 标准属性，确保兼容性 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 确保占满单元格宽度 */
  line-height: 1.5; /* 可根据需要调整行高 */
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/AuditInternTable.vue